import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
const AgentTab = ({ token, user_id, b64id, refresh, OrganisationDetail }) => {
    const ApplicableOption = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ];

    const [disableSubmit, setDisableSubmit] = useState(false);

    const initialValues = {
        air_is_overseas_agent: false,
        air_profit_sharing: "",
        air_is_local_agent: false,
        air_commission: "",
        air_incentive: "",
        sea_is_overseas_agent: false,
        sea_profit_sharing: "",
        sea_is_local_agent: false,
        sea_commission: "",
        sea_incentive: "",
        land_is_overseas_agent: false,
        land_profit_sharing: "",
        co_load_agent: false,
        currency_uplift_air_percentage: "",
        currency_uplift_air_value: "",
        currency_uplift_sea_percentage: "",
        currency_uplift_sea_value: "",
        borrow_AWB_is_GSA: false,
        borrow_AWB_GSA_percentage: "",
        borrow_AWB_IATA_code: "",
        borrow_AWB_account_no: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.customer_id = atob(b64id)
                axios.post(`${adminMainUrl}/api/organization/agent-add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });

    useEffect(() => {
        if (OrganisationDetail && OrganisationDetail?.EntityAgent) {
            formik.setFieldValue("air_is_overseas_agent", OrganisationDetail?.EntityAgent?.air_is_overseas_agent);
            formik.setFieldValue("air_profit_sharing", OrganisationDetail?.EntityAgent?.air_profit_sharing);
            formik.setFieldValue("air_is_local_agent", OrganisationDetail?.EntityAgent?.air_is_local_agent);
            formik.setFieldValue("air_commission", OrganisationDetail?.EntityAgent?.air_commission);
            formik.setFieldValue("air_incentive", OrganisationDetail?.EntityAgent?.air_incentive);
            formik.setFieldValue("sea_is_overseas_agent", OrganisationDetail?.EntityAgent?.sea_is_overseas_agent);
            formik.setFieldValue("sea_profit_sharing", OrganisationDetail?.EntityAgent?.sea_profit_sharing);
            formik.setFieldValue("sea_is_local_agent", OrganisationDetail?.EntityAgent?.sea_is_local_agent);
            formik.setFieldValue("sea_commission", OrganisationDetail?.EntityAgent?.sea_commission);
            formik.setFieldValue("sea_incentive", OrganisationDetail?.EntityAgent?.sea_incentive);
            formik.setFieldValue("land_is_overseas_agent", OrganisationDetail?.EntityAgent?.land_is_overseas_agent);
            formik.setFieldValue("land_profit_sharing", OrganisationDetail?.EntityAgent?.land_profit_sharing);
            formik.setFieldValue("co_load_agent", OrganisationDetail?.EntityAgent?.co_load_agent);
            formik.setFieldValue("currency_uplift_air_percentage", OrganisationDetail?.EntityAgent?.currency_uplift_air_percentage);
            formik.setFieldValue("currency_uplift_air_value", OrganisationDetail?.EntityAgent?.currency_uplift_air_value);
            formik.setFieldValue("currency_uplift_sea_percentage", OrganisationDetail?.EntityAgent?.currency_uplift_sea_percentage);
            formik.setFieldValue("currency_uplift_sea_value", OrganisationDetail?.EntityAgent?.currency_uplift_sea_value);
            formik.setFieldValue("borrow_AWB_is_GSA", OrganisationDetail?.EntityAgent?.borrow_AWB_is_GSA);
            formik.setFieldValue("borrow_AWB_GSA_percentage", OrganisationDetail?.EntityAgent?.borrow_AWB_GSA_percentage);
            formik.setFieldValue("borrow_AWB_IATA_code", OrganisationDetail?.EntityAgent?.borrow_AWB_IATA_code);
            formik.setFieldValue("borrow_AWB_account_no", OrganisationDetail?.EntityAgent?.borrow_AWB_account_no);
        }
    }, [OrganisationDetail])

    return (
        <div className='card p-3'>
            <form onSubmit={formik.handleSubmit}>
                {/* Air */}
                <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Air</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3 form-check">
                                        <input type="checkbox" className="form-check-input" id="air_is_overseas_agent"
                                            name="air_is_overseas_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('air_is_overseas_agent', event.target.checked)
                                            }}
                                            checked={formik.values.air_is_overseas_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="air_is_overseas_agent">
                                            OverSeas Agent
                                        </label>

                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="air_profit_sharing">
                                            Profit Sharing (%)
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            className="form-control form-control-sm "
                                            id="air_profit_sharing"
                                            name="air_profit_sharing"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.air_profit_sharing}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />

                                    </div>
                                </div>


                            </div>
                            <div className="row">
                                <div className="col-6">


                                    <div className="mb-3 form-check">
                                        <input type="checkbox" className="form-check-input" id="air_is_local_agent"
                                            name="air_is_local_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('air_is_local_agent', event.target.checked)
                                            }}
                                            checked={formik.values.air_is_local_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="air_is_local_agent">
                                            Local Agent
                                        </label>

                                    </div>
                                </div>



                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="air_commission">
                                            Commission (%)
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            // min={0}
                                            // max={100}
                                            className="form-control form-control-sm"
                                            id="air_commission"
                                            name="air_commission"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.air_commission}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />
                                    </div>
                                </div>


                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="air_incentive">
                                            Insentive (%)
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            // min={0}
                                            // max={100}
                                            className="form-control form-control-sm "
                                            id="air_incentive"
                                            name="air_incentive"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.air_incentive}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />
                                    </div>
                                </div>


                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                {/* Sea */}
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Sea</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3 form-check">
                                        <input type="checkbox" className="form-check-input" id="sea_is_overseas_agent"
                                            name="sea_is_overseas_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('sea_is_overseas_agent', event.target.checked)
                                            }}
                                            checked={formik.values.sea_is_overseas_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="sea_is_overseas_agent">
                                            OverSeas Agent
                                        </label>

                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="sea_profit_sharing">
                                            Profit Sharing (%)
                                        </label>
                                        <input
                                            type="text"
                                            // min={0}
                                            // max={100}
                                            maxLength={6}
                                            className="form-control form-control-sm "
                                            id="sea_profit_sharing"
                                            name="sea_profit_sharing"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.sea_profit_sharing}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />

                                    </div>
                                </div>


                            </div>
                            <div className="row">
                                <div className="col-6">


                                    <div className="mb-3 form-check">
                                        <input type="checkbox" className="form-check-input" id="sea_is_local_agent"
                                            name="sea_is_local_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('sea_is_local_agent', event.target.checked)
                                            }}
                                            checked={formik.values.sea_is_local_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="sea_is_local_agent">
                                            Local Agent
                                        </label>

                                    </div>
                                </div>



                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="sea_commission">
                                            Commission (%)
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            // min={0}
                                            // max={100}
                                            className="form-control form-control-sm"
                                            id="sea_commission"
                                            name="sea_commission"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.sea_commission}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />
                                    </div>
                                </div>


                                <div className="col-3">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="sea_incentive">
                                            Insentive (%)
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            // min={0}
                                            // max={100}
                                            className="form-control form-control-sm "
                                            id="sea_incentive"
                                            name="sea_incentive"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.sea_incentive}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />
                                    </div>
                                </div>


                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                {/* Land */}
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Land</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3 form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="land_is_overseas_agent"
                                            name="land_is_overseas_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('land_is_overseas_agent', event.target.checked)
                                            }}
                                            checked={formik.values.land_is_overseas_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="land_is_overseas_agent">
                                            OverSeas Agent
                                        </label>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3 form-check">
                                        <label className="form-label" htmlFor="land_profit_sharing">
                                            Profit Sharing
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={5}
                                            // min={0}
                                            // max={100}
                                            className="form-control form-control-sm "
                                            id="land_profit_sharing"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.land_profit_sharing}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                if ((value.match(/\./g) || []).length > 1) {
                                                    value = value.substring(0, value.lastIndexOf('.'));
                                                }
                                                event.target.value = value;
                                            }}
                                        />


                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                {/* Coload */}
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Co Load</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="mb-3 form-check">
                                        <input type="checkbox"
                                            className="form-check-input"
                                            id="co_load_agent"
                                            name="co_load_agent"
                                            onChange={(event) => {
                                                formik.setFieldValue('co_load_agent', event.target.checked)
                                            }}
                                            checked={formik.values.co_load_agent}
                                        />
                                        <label className="form-label mt-0" htmlFor="co_load_agent">
                                            Co-Load Agent
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                {/* Borrow AWB */}
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                            Borrow AWBs</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">


                                    <div className="mb-0 form-check">

                                        <label className="form-label mt-0" htmlFor="borrow_AWB_is_GSA">
                                            G.S.A. (Air)
                                        </label>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="borrow_AWB_is_GSA"
                                            name="borrow_AWB_is_GSA"
                                            onChange={(event) => {
                                                formik.setFieldValue('borrow_AWB_is_GSA', event.target.checked)
                                            }}
                                            checked={formik.values.borrow_AWB_is_GSA} />
                                    </div>
                                    <input
                                        // min={0}
                                        // max={100}
                                        type="text"
                                        maxLength={5}
                                        placeholder='Enter number'
                                        className="form-control form-control-sm"
                                        id="borrow_AWB_GSA_percentage"
                                        name="borrow_AWB_GSA_percentage"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.borrow_AWB_GSA_percentage}
                                        onInput={(event) => {
                                            let value = event.target.value;
                                            value = value.replace(/[^0-9.]/g, '');
                                            if ((value.match(/\./g) || []).length > 1) {
                                                value = value.substring(0, value.lastIndexOf('.'));
                                            }
                                            event.target.value = value;
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <div className="mb-0 ">
                                        <label className="form-label mt-0" htmlFor="borrow_AWB_IATA_code">
                                            Iata Code
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            id="borrow_AWB_IATA_code"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.borrow_AWB_IATA_code}
                                        />


                                    </div>
                                </div>
                                <div className="col-6">


                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="borrow_AWB_account_no">
                                            Account No
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={35}
                                            className="form-control form-control-sm "
                                            id="borrow_AWB_account_no"
                                            name="borrow_AWB_account_no"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.borrow_AWB_account_no}
                                            onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}

                                        />


                                    </div>
                                </div>

                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                {/* <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        
                        Shipping Agent</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 ">
                                            For Sea
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 ">
                                            For Air
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                   
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 ">
                                            For Land
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion> */}

                {/* CFX */}
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Currency uplift</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">

                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>
                                        </div>
                                        <div className="row">
                                            <div className="col-8">
                                                <input
                                                    type="text"
                                                    // min={0}
                                                    // max={100}
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_air_value"
                                                    name="currency_uplift_air_value"
                                                    placeholder='Enter For Air'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_air_value}
                                                    onInput={(event) => {
                                                        let value = event.target.value;
                                                        value = value.replace(/[^0-9.]/g, '');
                                                        if ((value.match(/\./g) || []).length > 1) {
                                                            value = value.substring(0, value.lastIndexOf('.'));
                                                        }
                                                        event.target.value = value;
                                                    }}
                                                />
                                            </div>
                                            <div className="col-4">

                                                <select
                                                    name="currency_uplift_air_percentage"
                                                    id="currency_uplift_air_percentage"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_air_percentage}
                                                    className="form-control form-control-sm"
                                                >
                                                    <option value=""></option>
                                                    <option value="%">%</option>
                                                    <option value="-">-</option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Land
                                            </label>

                                        </div>
                                        <div className="row">
                                            <div className="col-8">

                                                <input
                                                    type="text"
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_sea_value"
                                                    name="currency_uplift_sea_value"
                                                    placeholder='Enter For Land'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_sea_value}
                                                    onInput={(event) => {
                                                        let value = event.target.value;
                                                        value = value.replace(/[^0-9.]/g, '');
                                                        if ((value.match(/\./g) || []).length > 1) {
                                                            value = value.substring(0, value.lastIndexOf('.'));
                                                        }
                                                        event.target.value = value;
                                                    }}
                                                />
                                            </div>
                                            <div className="col-4">

                                                <select
                                                    name="currency_uplift_sea_percentage"
                                                    id="currency_uplift_sea_percentage"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_sea_percentage}
                                                    className="form-control form-control-sm"
                                                >
                                                    <option value=""></option>
                                                    <option value="%">%</option>
                                                    <option value="-">-</option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <hr />
                <div className="row justify-content-end mt-3 gap-2">
                    <button className="btn btn-primary text-xs w-fit" type="submit" disableSubmit={disableSubmit}>
                        {disableSubmit ? <> <i className="fas fa-spinner fa-spin"></i>Updating...</> : "Update"}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AgentTab